export enum TrainingPlanStatusEnum {
  PENDING_PROVIDER = "pending_provider",
  PENDING_EMPLOYEE = "pending_employee",
  PENDING_INVITATION = "pending_invitation",
  REGISTERED = "registered",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  TO_COMPLETE = "to_complete",
  CANCELED = "canceled",
  NOT_PRESENT = "not_present",
  NOT_COMPLETED = "not_completed",
  TO_ORGANIZE = "to_organize",
  NO_SHOW = "no_show",
  ORDER_IN_PROGRESS = "order_in_progress",
  FINISHED = "finished",
  /** Confirmed registration awaiting a session — grouped in the "À planifier" tab. */
  PENDING_DATE_CHOICE = "pending_date_choice",
  NO_SUITABLE_DATE = "no_suitable_date",
}

export enum TrainingPlanTypesEnum {
  PROJECTS = "project",
  SESSIONS = "session",
  ALL = "all",
}

export enum stepType {
  BILLING = "billing",
  REGISTERED = "registered",
}

export enum DeclarationStep {
  MONOTIMESLOT = "monoTimeslot",
  MULTITIMESLOT = "multiTimeslot",
  // HABILITATION = "habilitation",
}
